import React from 'react';
import { Button } from '../components/ui/Button';
import { Section } from '../components/ui/Section';
import { ArrowLeft, Utensils, Clock, Users, ChefHat } from 'lucide-react';
export function MealPage() {
  return <main className="min-h-screen w-full bg-white" data-id="element-228">
      {/* Header */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-50" data-id="element-229">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-230">
          <a href="/" className="inline-flex items-center text-[#1e3a8a] hover:text-[#1e3a8a]/80 transition-colors font-medium" data-id="element-231">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-232" />
            Volver al inicio
          </a>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-16 md:py-24 bg-gradient-to-b from-[#EFF6FF] to-white" data-id="element-233">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-234">
          <div className="text-center max-w-3xl mx-auto" data-id="element-235">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#DBEAFE] text-[#1e3a8a] font-semibold text-sm mb-6" data-id="element-236">
              MÉTODO 3–3–7
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1F2937] mb-6" data-id="element-237">
              Meal Prep para <br data-id="element-238" />
              <span className="text-[#1e3a8a]" data-id="element-239">Cerebro Saturado</span>
            </h1>
            <p className="text-lg md:text-xl text-[#4B5563] mb-8 leading-relaxed" data-id="element-240">
              El sistema anti-caos para comer bien sin el plan perfecto.
              Diseñado para tu "día malo", no para tu "yo ideal".
            </p>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <Section background="white" data-id="element-241">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-242">
          {[{
          icon: Utensils,
          title: '3 Proteínas',
          desc: 'Bases versátiles para toda la semana'
        }, {
          icon: ChefHat,
          title: '3 Vegetales',
          desc: 'Listos para usar sin esfuerzo'
        }, {
          icon: Clock,
          title: '7 Combinaciones',
          desc: 'Variedad sin volver a cocinar'
        }, {
          icon: Users,
          title: 'Menú Emergencia',
          desc: 'Para días imposibles'
        }].map((item, i) => <div key={i} className="bg-[#EFF6FF] p-6 rounded-xl border border-[#DBEAFE] text-center" data-id="element-243">
              <div className="bg-[#1e3a8a] w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-244">
                <item.icon className="w-7 h-7 text-white" data-id="element-245" />
              </div>
              <h3 className="text-lg font-bold text-[#1F2937] mb-2" data-id="element-246">
                {item.title}
              </h3>
              <p className="text-sm text-[#4B5563]" data-id="element-247">{item.desc}</p>
            </div>)}
        </div>
      </Section>

      {/* CTA Section */}
      <Section background="teal" className="text-center" data-id="element-248">
        <div className="max-w-2xl mx-auto" data-id="element-249">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1F2937] mb-6" data-id="element-250">
            ¿Lista para empezar?
          </h2>
          <p className="text-lg text-[#4B5563] mb-8" data-id="element-251">
            Obtén acceso inmediato al ebook y transforma tu relación con la
            comida.
          </p>

          <div className="bg-white p-8 rounded-2xl shadow-xl" data-id="element-252">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-253">
              <p className="text-xl text-[#6B7280] line-through" data-id="element-254">$19.99</p>
              <p className="text-4xl font-bold text-[#1e3a8a]" data-id="element-255">$6.39</p>
            </div>
            <p className="text-sm text-green-600 font-semibold mb-6" data-id="element-256">
              68% de descuento
            </p>

            <Button fullWidth onClick={() => window.location.href = 'https://www.mjebook.com/cart/43032191631478:1'} data-id="element-257">
              Descárgalo Aquí
            </Button>

            <p className="text-xs text-[#6B7280] mt-4" data-id="element-258">
              Pago seguro • Descarga inmediata • Acceso de por vida
            </p>
          </div>
        </div>
      </Section>

      {/* Footer */}
      <footer className="bg-[#1F2937] text-white py-8" data-id="element-259">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-260">
          <p className="text-sm text-gray-400" data-id="element-261">
            © 2024 Meal Prep para Cerebro Saturado. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>
    </main>;
}